import { Modal, Form, Input, message } from "antd";
import { useCreateExpenseSupplier } from "@/pages/Expenses/ManageExpense/hooks/useExpenseSuppliers";
import { useEffect } from "react";
import { CreateExpenseSupplierFormValues } from "@/pages/Expenses/ManageExpense/api/expenseSuppliers";

const { TextArea } = Input;

interface CreateModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const CreateModal = ({ isOpen, onClose, onSuccess }: CreateModalProps) => {
  const [form] = Form.useForm();
  const { mutate: createExpenseSupplier, isPending } =
    useCreateExpenseSupplier();

  const handleSubmit = async (values: CreateExpenseSupplierFormValues) => {
    createExpenseSupplier(values, {
      onSuccess: () => {
        message.success("Successfully created expense supplier");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  return (
    <Modal
      title="New Supplier"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Create"
      destroyOnHidden
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="contact_person" label="Contact Person">
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              type: "email",
              message: "Please enter a valid email",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="phone" label="Phone">
          <Input />
        </Form.Item>
        <Form.Item name="address" label="Address">
          <TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateModal;
